<template>
    <div>
        <div id="alert" :style="opacity" >
            <div>
                {{msg}}
            <span @click="closeAlert">×</span>
            </div>
        </div>
    </div>
</template>
<style>
    #alert{
        width: 50%;
        left: 25%;
        margin: 0;
        box-sizing: border-box;
        border-radius: 4px;
        position: fixed;
        overflow: hidden;
        display: flex;
        align-items: center;
        transition: opacity 0.2s;
        background-color: #fef0f0;
        color: #f56c6c;
        top:6%;
        height:50px ;


    }
    #alert div{width:100%;text-align: center;line-height: 50px;position: relative}
    #alert div span{display: block;position: absolute;right: 2%;top:0;color: #666666;cursor: pointer}

</style>

<script>
    export default {
        name: 'alert',
        props:['show','msg'],
        data () {
            return {
                opacity:{
                    opacity:1
                }
            }
        },
        watch: {

        },
        methods:{
            closeAlert(){
                this.$emit('showbox',false);
            },
            clearFun(){
                let self = this;
                setTimeout(function () {
                    self.closeAlert()
                },3000)
            }

        },
        created(){
            this.clearFun();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/alert.vue